// Získání article id z CNCArticleId via def-head.twig
export const getArticleId = (): string | null => {
  const CNCArticleIdMeta: HTMLMetaElement | null = document.querySelector(
    'meta[name="CNCArticleId"]'
  );

  return CNCArticleIdMeta?.getAttribute('content') || null;
};
export const isArticle = (): boolean => getArticleId() !== null;
